const tokenElements = document.getElementsByName("csrf-token")

// There is no csrf token when RAILS_ENV=test, which is undetectable when
// running tests in development. So when the element doesn't exist, assume this
// is why.
export const token =
  tokenElements.length === 0 ? null : tokenElements[0].getAttribute("content")
